<template>

  <div class="content_btn">
    <div class="content_btn_item" v-loading="element_loading" element-loading-text="权限加载中......"
      element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
     <!-- <button class="pre_btn_ok" v-if="if_add" @click="refresh_data('showblank')">
        新建
      </button> -->
      <button class="pre_btn_ok" v-if="if_sel" @click="refresh_data('sel')">
        查询
      </button>
      <button class="pre_btn_ok" v-if="if_sel" @click="refresh_data('new')">
        清空
      </button>
      <button class="btn_add" v-if="if_add" @click="refresh_data('add')">
        增加
      </button>
      <button class="pre_btn_ok" v-if="if_upd" @click="refresh_data('upd')">
        修改
      </button>
      <!-- <button class="pre_btn_ok btn_sub" @click="refresh_data('save')">
        保存
      </button> -->
      <button class="pre_btn_ok" v-if="if_sub" @click="refresh_data('sub')">
        提交
      </button>
      <button class="pre_btn_ok" v-if="if_bad" @click="refresh_data('bad')">
        作废
      </button>
      <button class="pre_btn_ok btn_del" v-if="if_del" @click="refresh_data('del')">
        删除
      </button>
      <button class="pre_btn_ok" v-if="if_exl" @click="refresh_data('exl_down')">
        导出Excel
      </button>
      <button class="pre_btn_ok" v-if="if_fileup" @click="refresh_data('filesel')">
        选择文件
      </button>
      <button class="pre_btn_ok" v-if="if_fileup" @click="refresh_data('fileup')">
        上传文件
      </button>
      <button class="pre_btn_ok" v-if="if_filelook" @click="refresh_data('filelook')">
        预览|下载
      </button>
      <button class="pre_btn_ok btn_del" v-if="if_filedel" @click="refresh_data('filedel')">
        删除文件
      </button>


    </div>
  </div>

</template>

<script>
  /*
名称：根据菜单编号和人员ID,显示不同的控制按钮
日期：2020-11-07
作者：hj

不要新建按钮

*/
  import api from '@/utils/type.js';
  import {
    Method_EasySelect
  } from '@/utils/loadhttpdata.js';

  export default {
    name: "pre_btn_control",
    data() {
      return {
        element_loading: false,
        if_sel: false,
        if_add: false,
        if_upd: false,
        if_del: false,
        if_sav: false,
        if_sub: false,
        if_bad: false,
        if_exl: false,
        if_fileup: false,
        if_filelook: false,
        if_filedel: false
      };
    },
    props: {
      pre_control: {
        type: String,
        default: ''
      }
    },
    watch: {
      pre_control(val) {
        // console.log('权限监测。。='+val.length);
        if (val != '') {
          this.load_data();
        }
      }
    },
    created: function() {
      // console.log('权限初始化='+this.pre_control);
      if (this.pre_control != '') {
        this.load_data();
      }
    },
    methods: {
      refresh_data: function(type) {
        this.$emit('button-event', type)
      },
      load_data: function() {
        this.element_loading = true;
        this.$post(
          api.http_method,
          Method_EasySelect('data_menu_btnrole', this.pre_control)
        ).then(res => {
          this.element_loading = false;
          res = JSON.parse(res);
          res = res.data;
          // console.log(res.data);
          // console.log('length=====' + res.data.length+' == '+this.pre_control);
          if (res.data.length == 0) {
            this.$message({
              message: '请先配置操作按钮权限!',
              type: 'warning'
            });
          } else {
            if (res.data[0].add == '1') {
              this.if_add = true;
            }
            if (res.data[0].upd == '1') {
              this.if_upd = true;
            }
            if (res.data[0].del == '1') {
              this.if_del = true;
            }
            if (res.data[0].sel == '1') {
              this.if_sel = true;
            }
            if (res.data[0].sub == '1') {
              this.if_sub = true;
            }
            if (res.data[0].bad == '1') {
              this.if_bad = true;
            }
            if (res.data[0].exl == '1') {
              this.if_exl = true;
            }
            if (res.data[0].fileup == '1') {
              this.if_fileup = true;
            }
            if (res.data[0].filelook == '1') {
              this.if_filelook = true;
            }
            if (res.data[0].filedel == '1') {
              this.if_filedel = true;
            }
          }
        });
      },


    }
  };
</script>


<style scoped>

</style>
